<!-- main app container -->
<ng-container
  *ngIf="{
    authenticated: isAuthenticated | async,
    user: currentUser | async,
    fullScreenView: isFullScreenView$ | async
  } as c"
>
  <div
    class="modus-layout"
    *ngIf="
      c.authenticated &&
        !router.url.includes('/signup') &&
        !router.url.includes('/landing') &&
        !router.url.includes('/login');
      else usePublicPageLayout
    "
  >
    <nav
      *ngIf="accept"
      class="navbar navbar-blue navbar-expand-sm modus-header border-primary pl-1"
      id="modus-header"
    >
      <a
        id="menuButton"
        *ngIf="!c.fullScreenView"
        data-modus-item="menu-btn"
        class="btn btn-lg btn-icon-only btn-text-dark mr-2"
        (click)="isSidebarOpen = !isSidebarOpen"
        ><i class="modus-icons menu-btn">menu</i></a
      >
      <modus-app-branding
        [logoPath]="'../assets/img/PCMILER_Logo_BW.svg'"
        [isClickable]="true"
      ></modus-app-branding>
      <div class="navbar-nav justify-content-end">
        <app-chat-support [currentUser]="c.user"></app-chat-support>
        <button
          class="btn btn-lg btn-icon-only btn-text-dark"
          type="button"
          (click)="openSupportPage()"
          aria-haspopup="true"
          aria-expanded="false"
          data-placement="bottom"
          tooltip="Help & &#013; Support"
          container="body"
          [adaptivePosition]="false"
          placement="bottom"
        >
          <i class="modus-icons material-icons">help</i>
        </button>
        <web-tools-menu
          *ngIf="!authenticationService.isPromoUser()"
        ></web-tools-menu>
      </div>
    </nav>
    <div
      class="modus-body sidebar-closed"
      data-modus-item="body"
      id="modusBody"
      [ngClass]="{
        'sidebar-open': isSidebarOpen,
        'sidebar-closed': !isSidebarOpen
      }"
    >
      <nav
        *ngIf="accept && !c.fullScreenView"
        id="mainSidebar"
        class="nav flex-column modus-sidebar"
      >
        <ul>
          <li>
            <a
              class="nav-link"
              routerLink="app"
              [routerLinkActiveOptions]="routerLinkActiveOptions"
              routerLinkActive="active"
            >
              <span
                class="left-nav-icon"
                tooltip="Routing"
                container="body"
                [adaptivePosition]="false"
                [isDisabled]="isSidebarOpen"
                placement="right"
                ><i class="modus-icons">route</i></span
              >
              Routing
            </a>
          </li>
          <li>
            <a
              class="nav-link"
              gtagEvent
              trackOn="click"
              action="ApplicationSettings_Panel"
              category="applicationSettings"
              [params]="{ event_label: 'applicationSettings_navigation' }"
              routerLink="/applicationSettings/application"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
            >
              <span
                class="left-nav-icon"
                tooltip="Application Settings"
                container="body"
                [adaptivePosition]="false"
                [isDisabled]="isSidebarOpen"
                placement="right"
                ><i class="modus-icon material-icons">tune</i></span
              >
              Application Settings
            </a>
          </li>
          <li *ngIf="!authenticationService.isPromoUser()">
            <a
              class="nav-link"
              gtagEvent
              trackOn="click"
              action="AccountSettings_Panel"
              category="MyAccount"
              [params]="{ event_label: 'myAccount_navigation' }"
              routerLink="accountSettings/myAccount"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
            >
              <span
                class="left-nav-icon"
                tooltip="Account Settings"
                container="body"
                [adaptivePosition]="false"
                [isDisabled]="isSidebarOpen"
                placement="right"
                ><i class="modus-icon material-icons">account_circle</i></span
              >
              Account Settings
            </a>
          </li>
          <li>
            <a
              class="nav-link"
              gtagEvent
              trackOn="click"
              (click)="clearAlerts()"
              action="RouteProfiles_Panel"
              category="routeProfiles"
              [params]="{ event_label: 'routeProfiles_navigation' }"
              routerLink="/routeProfiles/list"
              [routerLinkActiveOptions]="{ exact: true }"
              routerLinkActive="active"
            >
              <span
                class="left-nav-icon"
                tooltip="Route Profiles"
                container="body"
                [adaptivePosition]="false"
                [isDisabled]="isSidebarOpen"
                placement="right"
              >
                <i class="modus-icons" icon>route_options</i>
              </span>
              Route Profiles
            </a>
          </li>
        </ul>
      </nav>
      <router-outlet></router-outlet>
    </div>
    <app-footer
      *ngIf="accept"
      [currentUser]="c.user"
      [fullScreenView]="c.fullScreenView"
    ></app-footer>

    <ng-container *ngIf="{ showInModal: showInModal$ | async } as alertMsg">
      <app-modal-alert *ngIf="!alertMsg.showInModal"></app-modal-alert>
    </ng-container>
  </div>
</ng-container>
<!-- Layout for public pages (e.g., login, reset, etc.) -->
<ng-template #usePublicPageLayout>
  <div
    *ngIf="(isAuthenticated | async) !== true"
    class="full-page-grid bg-panel-background fullHeight"
  >
    <div class="container p-0">
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-template>
